
const post_url = 'micro-auth/signin'

export const Login = async (user: any) => {
       return await $fetch(post_url, {
              method: "POST", body: user, baseURL: useRuntimeConfig().public.apiBaseUrl as string
       })
}

